const exampleJobDataProp = {
  backoffice_vanity: ["demo"],
  career_level: [],
  cluster: ["Web- und Softwareentwicklung"],
  company: "Breuner | Med AG",
  contract_type: [],
  coordinate: [[50.9333, 6.95]],
  country: ["Deutschland"],
  custom_filter_1: ["Berufserfahrene"],
  custom_filter_2: [],
  custom_filter_3: [],
  custom_filter_4: [],
  custom_filter_5: [],
  custom_filter_6: [],
  department: ["IT"],
  external_id: "84669f2a-05bb-53e7-9146-eb5ebb0f509f",
  full_address: ["Niehler Straße 104, 50733 Köln"],
  id: "2b0cdece-6a6e-4a7b-a456-cbc0c6c6ce10_demo",
  jobshop_id: [],
  location: ["Köln"],
  location_count: 1,
  salary: "3 - 5 Sheep",
  schedule: ["Vollzeit"],
  start_date: "2025-07-22",
  start_date_timestamp: 1753142400,
  start_year: 2025,
  tenant_id: "olsen-breuner",
  title: "Senior Java Entwickler (m/w/d)",
  sub_title: "You better know Kotlin too.",
  url: "https://olsen-breuner.stage.jobshop.dev/demo/jobs/senior-java-entwickler-m-w-d/2b0cdece-6a6e-4a7b-a456-cbc0c6c6ce10",
  application_url: "https://www.example.com/apply",
  work_mode: ["Remote"],
  working_hours: ["40h per week"],
  title_slug: "senior-java-entwickler-mwd",
  description:
    "<ul>\n\t<li>Technische Leitung von Entwicklerteams übernehmen</li>\n\t<li>IT-Systeme und Fachkonzepte auseinandernehmen</li>\n\t<li>Software-Architekturen entwerfen, die Substanz haben</li>\n\t<li>Selbst Software designen, entwickeln und testen        </li>\n\t<li>Reviews durchführen, die weiterhelfen</li>\n\t<li>Methoden und Prozesse für Softwareentwicklung konzipieren und kontinuierlich optimieren</li>\n\t<li>Tools und Frameworks einführen, die unsere Effizienz steigern</li>\n</ul>\n",
  expectation:
    "<ul>\n\t<li>Abgeschlossenes Hochschulstudium der Informatik mit mindestens 7 Jahre Berufserfahrung in der Softwareentwicklung mit Java SE/EE</li>\n\t<li>Fundierte Kenntnisse in der Anwendung aktueller Java Frameworks und gängiger Modellierungssprachen (z.B. UML) und idealerweise Erfahrung mit agilen Software-Entwicklungsprozessen (z.B. Scrum)</li>\n\t<li>Hohes Qualitätsbewusstsein und praktische Erfahrung im Einsatz von Qualitätssicherungsmaßnahmen (z.B. Unit- und Integrationstests, statische Codeanalyse, Code Reviews)</li>\n\t<li>Analytisches Denkvermögen, Kommunikations- und Teamfähigkeit</li>\n\t<li>Sehr gute Englischkenntnisse in Wort und Schrift</li>\n</ul>\n",
  introduction:
    "We are always hiring talented individuals for the many roles it takes to build our product and company. <br> If you don't see an open role on the site, but are interested in joining our team, please submit your resume using the link below, and include a brief cover letter highlighting why you feel you would be a great addition to us. Please note that our team is small and we can only respond to candidates that we see a potential role fit for.",
  about: "Duis bibendum. Morbi non quam nec dui luctus rutrum. Nulla tellus.",
  offering:
    "Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
  contact_text:
    "In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante. Nulla justo.\n\nAliquam quis turpis eget elit sodales scelerisque. Mauris sit amet eros. Suspendisse accumsan tortor quis turpis.",
  additional:
    "Integer ac leo. Pellentesque ultrices mattis odio. Donec vitae nisi.\n\nNam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus.",
  offer_uuid: "2b0cdece-6a6e-4a7b-a456-cbc0c6c6ce10",
  create_date: "9/21/2026",
  create_date_timestamp: 1764849239,
  last_modified: "5/31/2026",
  last_modified_timestamp: 1760850986,
  contract_time: "0.0005 Millenia",
  company_logo: "http://dummyimage.com/x.png/cc0000/ffffff",
  company_url: "https://www.example.com/company",
  contact_data: {
    first_name: "Dodie",
    last_name: "Braund",
    email: "dbraund3@t.co",
    phone: "+84 982 142 2264",
    city: "Milton",
    street: "86490 Merry Park",
    job_position: "General Manager",
  },
  benefits: [
    "open architecture",
    "executive",
    "Open-source",
    "middleware",
    "process improvement",
  ],
  // language skills are initially not included in Typesense, since we decided to not render them on the JDP. Still added them here for testing purposes.
  language_skills: [
    {
      uuid: "3fe4310f-94ec-42c5-a093-a6bd93bb0fa4",
      code: "de",
      level: "4",
      title: "Deutsch",
    },
    {
      uuid: "09ec67b7-8ee7-4188-a18e-33ada4584ed7",
      code: "en",
      level: "3",
      title: "Englisch",
    },
  ],
};

export default exampleJobDataProp;
